export default {
  title01: "Tiempo actual",
  title02: "24 Horas",
  title03: "Ver la previsión del tiempo para 10 días",
  title04: "Índice de Calidad del Aire (ICA)",
  title05: "Ver toda la información",
  title06: "AMANECER Y ATARDECER",
  title07: "FASE DE LA LUNA",
  title08: "Próxima luna llena",
  title09: "Próxima luna nueva",
  title10: "DÍA",
  title11: "NOCHE",
  title12: "Amanecer",
  title13: "Atardecer",
  title14: "Salida de la luna",
  title15: "Puesta de la luna",
  title16: "Fuente",
  title17: "Inicio",
  title18: "Fin",
  title19: "Utilizar ubicación actual",
  title20: "Buscar ciudad",
  title21: "Sensación térmica",
  title22: "Sensación térmica a la sombra",
  title23: "Ahora",
  title24: "Hoy",
  title25: "Dom.",
  title26: "Lun.",
  title27: "Mar.",
  title28: "Mié.",
  title29: "Jue.",
  title30: "Vie.",
  title31: "Sáb.",
  title32: "Cargando...",
  title33: "Ahora",
  title34: "Por horas",
  title35: "Por días",
  title36: "Sol y luna",
  title37: "Calidad del aire",
  title38: "Contactar con: xlf550402@gmail.com",
  title39: "Acuerdo de privacidad",
  title40: "Copyright © comfortweather.com 2020 - 2025. Todos los derechos reservados",
  title41: "Datos proporcionados por",
  title42: "Temp. Máx.",
  title43: "Temp. Mín.",
  title44: "Aceptar",
  title45: "¡Gracias por usar ComfortWeather! Para proteger mejor sus derechos e intereses legales, lea atentamente la ",
  title46: "Política de Privacidad",
  title47: " antes de usarla.",
  title48: "",
  title49: "Contactar con: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2025. Todos los derechos reservados",
  title51: "¡Gracias por usar 24hweather! Para proteger mejor sus derechos e intereses legales, lea atentamente la ",
};
